import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeader";
import PopupConfirmation from "../../client/third-party-casino/popup-confirmation";
import { useNavigate, Link } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";

export default function RoyalCasino() {
  const [balance, setBalance] = useState(0);
  const [username, setUsername] = useState("");
  const [expouser, setExpouser] = useState(0);
  const [showRules, setShowRules] = useState(true);
  const navigate = useNavigate();

  const [launchURL, setLaunchURL] = useState("");

  const userInfo = useSelector((state) => state.userStore);

  useEffect(() => {
    setUsername(userInfo.data.uname);
    setBalance(parseInt(userInfo.data.bz_balance));
    setExpouser(parseInt(userInfo.data.opin_bal - userInfo.data.bz_balance));
    //}
  }, [userInfo, setUsername, setExpouser, setBalance]);

  const closeBetSlip = (action) => {
    setShowRules(false);
    if (!action) {
      navigate("/home");
    }
  };

  const callBackend = async () => {
    let postData = JSON.stringify({
      providerCode: "AC",
      gameCode: ""
    });

    try {
      const response = await axiosInstance.post(
        "/th-casino/world-casino",
        postData
      );

      setLaunchURL(response.data.launchURL);
      console.log("response-launchURL->", response.data);
    } catch (error) {
      console.error("Error updating password:", error);
      //alert("Failed to update password.");
    } finally {
      //setSubmitting(false);
    }
  };

  useEffect(() => {
    callBackend();
  }, []);

  return (
    <ClientLayoutWithOutHeader showLoader={false}>
      <style>{`  
          .home-section {
            position: relative;
            height: 100vh;
            left: 0;
            background:white;

            width: calc(100% - 0px);
            transition: all 0.1s ease;
        }  

`}</style>
      <section class="home-section">
        <div
          class="bodyheight"
          style={{ height: "100vh", width: "100%", background: "#0b040e" }}
        >
          <iframe
            class="iframetemplate"
            src={launchURL}
            style={{ width: "100%", height: "100vh", border: "0px" }}
          ></iframe>
        </div>
      </section>
      <PopupConfirmation closeBetSlipParent={closeBetSlip} show={showRules} />
    </ClientLayoutWithOutHeader>
  );
}
